import Text from '@service-victoria/component-library/components/Text';
import React from 'react';
import { url } from 'app/utils';

export default function FAQs() {
  return (
    <>
      <Text.Body>
        Please refer to FAQs at{' '}
        <Text.Link
          target='_blank'
          value='getactive.vic.gov.au/vouchers/info-for-providers'
          href='https://www.getactive.vic.gov.au/vouchers/info-for-providers/'
          showExtraLink
        />
      </Text.Body>
      <Text.Heading.H3 fontWeight={600}>How we use your information</Text.Heading.H3>
      <Text.Body>
        We collect personal and business information that Department of Jobs, Skills, Industry and
        Regions (DJSIR) needs to process your voucher redemption for the Get Active Kids Voucher
        program.
      </Text.Body>
      <Text.Body>
        DJSIR administers the Get Active Kids Voucher program. The program supports Victorian kids
        to participate in organised sport and recreation activities. Your information will be used
        to redeem your vouchers, program administration and program review.
      </Text.Body>
      <Text.Body>
        You must complete all fields to be eligible. We can’t process your redemption without all
        the requested information.
      </Text.Body>
      <Text.Body>
        We’ll share this information with DJSIR to process your application, for research and
        evaluation and to send you updates, or where permitted by law.
      </Text.Body>
      <Text.Body>
        DJSIR may share this information with Commonwealth agencies and the Victorian State Sporting
        Association or Vitorian State Sport and Recreation Body.
      </Text.Body>
      <Text.Body>
        You can ask to access and correct your personal information using the contact details set
        out in our{' '}
        <Text.Link target='_blank' href={`${url.getSvDomain()}/privacy-and-security`}>
          Privacy and Security Policy
        </Text.Link>
        . Once we pass your information on to DJSIR, you can request to access and correct your
        personal information by emailing the DJSIR Privacy Unit at{' '}
        <Text.Link target='_blank' href='mailto:privacy@ecodev.vic.gov.au'>
          privacy@ecodev.vic.gov.au
        </Text.Link>
        . A copy of DJSIR’s privacy statement is located at{' '}
        <Text.Link target='_blank' href='https://djsir.vic.gov.au/privacy'>
          www.djsir.vic.gov.au/privacy
        </Text.Link>
        .
      </Text.Body>
    </>
  );
}
